export const generativeAiAgentIdLogsDetail = "/generative_ai/agent/:id/logs/:invocation_id";
